import OrderService from "../../../services/order.service";

/**
 * Obtiene el preparador de Nave 1 de cada pedido, para imprimirlo en el ticket de Nave 2.
 *
 * DECISION: se lee de `ventas/personas` (la preparación de Nave 1, tabla final_ventas),
 * igual que hace la pantalla de Nave 1, en vez de arrastrarlo por la URL desde el
 * listado: a esta página también se llega escaneando el QR o desde una notificación.
 *
 * Nunca falla: si un pedido no se puede consultar su preparador queda a null, porque
 * un error aquí no debe impedir imprimir el ticket.
 *
 * @param {Array<{numero: string, tipo: string}>} pedidos - Pedidos "SERIE-NUMERO" y su tipo
 * @param {number} year - Ejercicio
 * @returns {Promise<Array<{pedido: string, preparador: (string|null)}>>}
 */
export const obtenerPreparadoresNave1 = (pedidos, year) => Promise.all(
    pedidos.map(async ({ numero, tipo }) => {
        try {
            const personas = await OrderService.getPersonsOrder(numero, 'ventas', year, tipo || 'albaran');
            return { pedido: numero, preparador: personas?.[0]?.preparado || null };
        } catch (error) {
            console.error(`Error al obtener el preparador de nave 1 del pedido ${numero}:`, error);
            return { pedido: numero, preparador: null };
        }
    })
);
